import React from 'react';
import { observer } from 'mobx-react-lite';
import { consentStore } from './consentStore';
import { ConsentCategory } from './cookieCatalogue';
import './consent.css';

export type GateKind = 'video' | 'map' | 'content';

const TEXT_KEY: Record<GateKind, string> = { video: 'BlockedVideo', map: 'BlockedMap', content: 'BlockedContent' };

export const ConsentPlaceholder = observer(({ kind, className }: { kind: GateKind; className?: string }) => (
  <div className={'cc-placeholder' + (className ? ` ${className}` : '')}>
    <p>{consentStore.t(TEXT_KEY[kind])}</p>
    <button type="button" className="cc-btn" onClick={() => consentStore.openDialog()}>
      {consentStore.t('BlockedButton')}
    </button>
  </div>
));

/** Renders children only once `category` is accepted; otherwise a same-size placeholder that opens the dialog. */
export const ConsentGate = observer(
  ({ category = 'marketing', kind = 'content', className, children }: { category?: ConsentCategory; kind?: GateKind; className?: string; children: React.ReactNode }) =>
    consentStore.hasConsent(category) ? <>{children}</> : <ConsentPlaceholder kind={kind} className={className} />
);

export default ConsentGate;
